import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { trackEvent } from "@/lib/analytics";

// Page de retour de l'OAuth Google (route publique).
// Google renvoie l'utilisateur ici avec le session_id dans le fragment d'URL :
//   /auth/google#session_id=xxxx
// On l'échange côté serveur contre notre JWT, puis on connecte l'utilisateur.
export default function GoogleCallback() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return; // évite le double appel (StrictMode)
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    // Nettoie le fragment (le session_id est à usage unique).
    window.history.replaceState({}, "", "/auth/google");

    if (!sessionId) {
      toast.error("Connexion Google annulée.");
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        login(data.token, data.user);
        trackEvent("login", { method: "google" });
        toast.success("Connexion réussie");
        const u = data.user;
        if (u?.role === "admin") navigate("/admin", { replace: true });
        else if (u?.org_type === "FINAL_CLIENT") navigate("/app/marketplace", { replace: true });
        else navigate("/app", { replace: true });
      } catch (err) {
        setError(true);
        toast.error(formatApiErrorDetail(err.response?.data?.detail));
        setTimeout(() => navigate("/login", { replace: true }), 2500);
      }
    })();
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg" data-testid="google-callback">
      <div className="font-mono text-muted text-sm animate-pulse">
        {error ? "Échec de la connexion Google…" : "Connexion à interKO…"}
      </div>
    </div>
  );
}
